/** Contextual response actions helpers — consume AskResponseV1.response_actions only. */

export const LENS_CONTEXTUAL_ACTIONS_TELEMETRY_ENABLED =
    process.env.REACT_APP_LENS_CONTEXTUAL_ACTIONS_TELEMETRY === 'true';

/** Mirrors backend LEGACY_CREATE_KEY_MAP for create-action sidebars. */
export const LEGACY_CREATE_KEY_HANDLERS = {
    create_observation: 'observation',
    create_task: 'task',
    create_irl: 'irl',
    add_to_raid: 'raid',
    add_to_action_log: 'action_log',
};

/** Normalize API response_actions payload. */
export function normalizeResponseActions(raw) {
    if (!raw || typeof raw !== 'object') return null;
    const primary = normalizeActionPayload(raw.primary);
    let secondary = normalizeActionPayload(raw.secondary);
    // Guard: backend should not emit the same key twice, but collapse if it does.
    if (primary && secondary && primary.key === secondary.key) {
        secondary = null;
    }
    if (!primary && !secondary) return null;
    return {
        context_version: raw.context_version ?? 1,
        trace_id: raw.trace_id ?? null,
        primary,
        secondary,
        utilities: Array.isArray(raw.utilities) ? raw.utilities : ['copy', 'more'],
    };
}

function normalizeActionPayload(raw) {
    if (!raw || typeof raw !== 'object' || !raw.key) return null;
    return {
        candidate_id: raw.candidate_id || '',
        key: String(raw.key),
        label: String(raw.label || raw.key),
        kind: raw.kind === 'navigate' ? 'navigate' : 'create',
        route: raw.route || null,
        target: raw.target || null,
        prefill: raw.prefill || null,
    };
}

/** Prefer persisted meta.response_actions, then live payload. */
export function resolveResponseActions({ responseActions = null, meta = null } = {}) {
    const fromPayload = normalizeResponseActions(responseActions);
    if (fromPayload) return fromPayload;
    const metaActions =
        meta && typeof meta === 'object' ? meta.response_actions : null;
    return normalizeResponseActions(metaActions);
}

/** Render footer when backend supplied actions and/or contextual follow-ups. */
export function shouldUseContextualFooter(
    responseActions,
    { askData = null, hasResponseActionsField = false } = {},
) {
    if (responseActions) return true;
    if (hasResponseActionsField && resolveFollowUpQuestions(askData || {}).length > 0) {
        return true;
    }
    return false;
}

export function resolveFollowUpQuestions(data = {}) {
    const questions = [];
    const seen = new Set();
    const add = value => {
        const text = String(value || '').trim();
        const key = text.toLowerCase();
        if (!text || seen.has(key)) return;
        seen.add(key);
        questions.push(text);
    };

    const alignment = data?.alignment_analysis;
    if (alignment && typeof alignment === 'object') {
        for (const question of alignment.recommended_follow_up_questions || []) {
            add(question);
        }
    }

    const irlValidation = data?.irl_claim_validation;
    if (irlValidation && typeof irlValidation === 'object') {
        for (const question of irlValidation.follow_up_questions || []) {
            add(question);
        }
    }

    const prefillQuestion = data?.response_actions?.primary?.prefill?.question;
    add(prefillQuestion);

    return questions.slice(0, 5);
}
